import React from "react";
import { Select } from "../../../shared/Select/Select";
import styles from "./scss/SelectTimeCategory.module.scss";

const SelectTimeCategory = ({ availableTrackAs, onChange, value }) => {
  const options = Object.values(availableTrackAs).map((item) => ({
    label: item.display_name,
    value: item.id,
  }));

  return (
    <div className={styles.selectTimeCategoryContainer}>
      <Select
        placeholder="Select Time Category"
        options={options}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default SelectTimeCategory;
